var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
var BackgroundBar = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", "px;\n  width: 100%;\n  ", "\n"], ["\n  height: ", "px;\n  width: 100%;\n  ", "\n"])), function (props) { return props.height; }, function (props) {
    return props.percent <= 50
        ? "\n          background: rgba(105,236,206,0.2);\n        "
        : props.percent <= 80 ? "\n          background: rgba(255,102,51,0.2);\n        " : "\n        background: rgba(239,45,86,0.2);\n      ";
});
var ForegroundBar = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: ", "px;\n  width: 100%;\n  ", "\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: ", "px;\n  width: 100%;\n  ", "\n"])), function (props) { return props.height; }, function (props) {
    return props.percent <= 50
        ? "\n          background: #69ecce;\n        "
        : props.percent <= 80 ? "\n          background: #ff6633;\n        " : "\n        background: #ef2d56;\n      ";
});
var ProgressBar = function (_a) {
    var percent = _a.percent, _b = _a.config, config = _b === void 0 ? {
        height: 16,
        extraClassNames: "my-3",
        radius: 4,
    } : _b, _c = _a.color, color = _c === void 0 ? "#69ECCE" : _c;
    return (_jsxs("div", __assign({ className: "d-flex flex-row position-relative " + config.extraClassNames }, { children: [_jsx(BackgroundBar, { height: config.height, radius: config.radius, percent: percent }, void 0), _jsx(ForegroundBar, { height: config.height, percent: percent, style: {
                    width: percent + "%",
                }, radius: config.radius }, void 0)] }), void 0));
};
export default ProgressBar;
var templateObject_1, templateObject_2;
//# sourceMappingURL=ProgressBar.js.map